import { en as layoutsAdditionalFeatures } from 'Components/ContractGenerator/layouts/AdditionalFeatures';
import { en as layoutsCard } from 'Components/ContractGenerator/layouts/Card';
import { en as layoutsComparisonTable } from 'Components/ContractGenerator/layouts/ComparisonTable';
import { en as layoutsFooter } from 'Components/ContractGenerator/layouts/Footer';
import { en as layoutsFooterButtonStep2 } from 'Components/ContractGenerator/layouts/Footer/ButtonStep2';
import { en as layoutsPriceSummary } from 'Components/ContractGenerator/layouts/PriceSummary';
import { en as layoutsShare } from 'Components/ContractGenerator/layouts/Share';
import { en as layoutsShareModalsCopyLink } from 'Components/ContractGenerator/layouts/Share/Modals/CopyLink';
import { en as layoutsShareModalsCreateLink } from 'Components/ContractGenerator/layouts/Share/Modals/CreateLink';
import { en as layoutsShareModalsCreateLinkLinkSettings } from 'Components/ContractGenerator/layouts/Share/Modals/CreateLink/LinkSettings';
import { en as layoutsShareModalsCreateLinkLinkSettingsType } from 'Components/ContractGenerator/layouts/Share/Modals/CreateLink/LinkSettings/Setting/Type';
import { en as layoutsShareModalsCreateLinkLinkSettingsValue } from 'Components/ContractGenerator/layouts/Share/Modals/CreateLink/LinkSettings/Setting/Value';
import { en as login } from 'Components/ContractGenerator/pages/Login';
import { en as step1Header } from 'Components/ContractGenerator/pages/Step1/Header';
import { en as step1Area } from 'Components/ContractGenerator/pages/Step1/Products/Area';
import { en as step1Product } from 'Components/ContractGenerator/pages/Step1/Products/Product';
import { en as step1SettingsArea } from 'Components/ContractGenerator/pages/Step1/SettingsArea';
import { en as step1SettingsAreaAccommodationType } from 'Components/ContractGenerator/pages/Step1/SettingsArea/AccommodationType';
import { en as step2ContractData } from 'Components/ContractGenerator/pages/Step2/ContractData';
import { en as step2ContractDataForm } from 'Components/ContractGenerator/pages/Step2/ContractData/Form';
import { en as step2Extensions } from 'Components/ContractGenerator/pages/Step2/Extensions';
import { en as step2PaymentType } from 'Components/ContractGenerator/pages/Step2/PaymentType';
import { en as step2Selection } from 'Components/ContractGenerator/pages/Step2/Selection';
import { en as step3Selection } from 'Components/ContractGenerator/pages/Step3/Selection';
import { en as step3Summary } from 'Components/ContractGenerator/pages/Step3/Summary';
import { en as step4 } from 'Components/ContractGenerator/pages/Step4';
import { en as step5 } from 'Components/ContractGenerator/pages/Step5';

const app = {
	userActions: {
		backToStart: 'Back to the start',
		toSummary: 'To summary',
		summary: 'Summary',
		toBooking: 'To booking',
		submit: 'Confirm booking with costs',
		next: 'Next',
		back: 'Back',
		choose: 'Choose',
		delete: 'Remove',
		inquire: 'Request',
		change: 'Change',
		close: 'Close',
		cancel: 'Cancel'
	},
	userFeedback: {
		api: {
			error: 'Error loading the product data. Please try again later.'
		}
	},
	taxInfo: '*Prices without tax',
	yes: 'Yes',
	no: 'No',
	captchaRequired: 'Please confirm you are not a robot to continue.',
	fieldsInvalid: 'Please fill out all fields correctly.',
	errorMessages: {
		unknown: {
			description: 'Error loading product data. Please try again later.'
		},
		520: {
			title: 'Link does not exist',
			description:
				'You tried to open a previously saved link of the contract generator. Unfortunately, the link provided no longer exists.'
		}
	}
};

const en = {
	app,
	layouts: {
		card: layoutsCard,
		additionalFeatures: layoutsAdditionalFeatures,
		footer: {
			...layoutsFooter,
			buttonStep2: layoutsFooterButtonStep2
		},
		priceSummary: layoutsPriceSummary,
		share: {
			...layoutsShare,
			modals: {
				createLink: {
					...layoutsShareModalsCreateLink,
					linkSettings: {
						...layoutsShareModalsCreateLinkLinkSettings,
						setting: {
							type: layoutsShareModalsCreateLinkLinkSettingsType,
							value: layoutsShareModalsCreateLinkLinkSettingsValue
						}
					}
				},
				copyLink: layoutsShareModalsCopyLink
			}
		},
		comparisonTable: layoutsComparisonTable
	},
	pages: {
		step1: {
			header: step1Header,
			settingsArea: { ...step1SettingsArea, accommodationType: step1SettingsAreaAccommodationType },
			products: {
				product: step1Product,
				area: step1Area
			}
		},
		step2: {
			selection: {
				...step2Selection
			},
			extensions: {
				...step2Extensions
			},
			paymentType: {
				...step2PaymentType
			},
			contractData: {
				...step2ContractData,
				form: step2ContractDataForm
			}
		},
		step3: {
			selection: {
				...step3Selection
			},
			summary: {
				...step3Summary
			}
		},
		step4: {
			...step4
		},
		step5: {
			...step5
		},
		login: {
			...login
		}
	}
};

export default en;
